export default "__VITE_ASSET__3gWlPd0UUi0pz5xFbx$YtA__";